module.exports = __webpack_public_path__ + "static/media/chi-siamo-image-1.b0cceb99.jpg";